// extracted by mini-css-extract-plugin
module.exports = {"six_col_layout":"IrdHu","subsection_spacing":"H5VUo","nonGrid":"cysHA","cards":"v8ASR","leadplusText":"ozOtN","fontBold":"FBFab","shopping_destination":"nhhXw"};